import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import './Impressum.scss';

const Impressum = () => {
    return (
        <>
            <SEO
                title="Impressum | Zahnarztpraxis Roman Boretskyi"
                description="Impressum und rechtliche Angaben der Zahnarztpraxis Roman Boretskyi in Tönisvorst."
                path="/impressum"
            />
            <Navbar />
            <section className='section-bg section-common impressum-section pt-100 pb-70'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 mx-auto">
                            <h1>Impressum</h1>
                            
                            <h2>Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz)</h2>
                            <p>
                                Zahnarztpraxis Roman Boretskyi<br />
                                Roman Boretskyi<br />
                                Kornstraße 53a<br />
                                47918 Tönisvorst<br />
                                Deutschland
                            </p>

                            <h2>Kontakt</h2>
                            <p>
                                Telefon: 02151803208<br />
                                E-Mail: anmeldung@zahnarzt-st-toenis.de
                            </p>

                            <h2>Berufsbezeichnung und berufsrechtliche Regelungen</h2>
                            <p>
                                Berufsbezeichnung: Zahnarzt<br />
                                Zuständige Kammer: Zahnärztekammer Nordrhein<br />
                                Verliehen in: Deutschland
                            </p>

                            <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
                            <p>
                                Roman Boretskyi<br />
                                Kornstraße 53a<br />
                                47918 Tönisvorst<br />
                                Deutschland
                            </p>

                            <h2>Haftungsausschluss</h2>
                            
                            <h3>Haftung für Inhalte</h3>
                            <p>
                                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. 
                                Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte 
                                können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter 
                                sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten 
                                nach den allgemeinen Gesetzen verantwortlich.
                            </p>

                            <h3>Haftung für Links</h3>
                            <p>
                                Unser Angebot enthält Links zu externen Webseiten Dritter, auf 
                                deren Inhalte wir keinen Einfluss haben. Deshalb können wir für 
                                diese fremden Inhalte auch keine Gewähr übernehmen. Für die 
                                Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter 
                                oder Betreiber der Seiten verantwortlich.
                            </p>

                            <h3>Urheberrecht</h3>
                            <p>
                                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf 
                                diesen Seiten unterliegen dem deutschen Urheberrecht. Die 
                                Vervielfältigung, Bearbeitung, Verbreitung und jede Art der 
                                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen 
                                der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Impressum;

